// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicDesktopV1OffersGetOffersRequest,
  TPublicDesktopV1OffersGetOffersModel,
  IMappers,
  TPublicDesktopV1OffersGetOffersResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchOffersDesktopResponseV2Schema } from '../../../../entities/search_offers_desktop_response_v2/SearchOffersDesktopResponseV2Schema';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createPublicDesktopV1OffersGetOffersModel(
  parameters: TPublicDesktopV1OffersGetOffersRequest,
): TPublicDesktopV1OffersGetOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'commercial-search-offers',
    pathApi: '/desktop/v1/offers/get-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicDesktopV1OffersGetOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicDesktopV1OffersGetOffersRequest;
}

export async function fetchPublicDesktopV1OffersGetOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicDesktopV1OffersGetOffersOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicDesktopV1OffersGetOffersResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicDesktopV1OffersGetOffersModel(parameters),
    config,
  )) as FetchResponse<TPublicDesktopV1OffersGetOffersResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchOffersDesktopResponseV2Schema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicDesktopV1OffersGetOffersResponse>;
}
